module.exports = __webpack_public_path__ + "img/background_homescreen.6c320711.jpg";